import { api } from 'app/views/utils/api'
import settings from 'settings'
import { SET_VERSIONS, SET_INITIAL_FILE } from './codeReview'

const SET_LOADING_ASSESSMENTS = 'assessments/SET_LOADING_ASSESSMENTS'
const SET_ASSESSMENTS = 'assessments/SET_ASSESSMENTS'

const SET_ASSESSMENT_DETAIL = 'assessments/SET_ASSESSMENT_DETAIL'
export const UPDATE_ASSESSMENT_USED_HINTS = 'assessments/UPDATE_ASSESSMENT_USED_HINTS'

const SHIFT_COMPLETED_ASSESSMENT_CONTENT = 'assessments/SHIFT_COMPLETED_ASSESSMENT_CONTENT'

const UPDATE_TIME_LEFT_CURRENT_QUESTION = 'assessments/SET_TIME_LEFT_CURRENT_QUESTION'

const initialState = {
  customAssessments: [],
  // hackeduAssessments: [],
  loadingAssessments: true,
  freeAssessments: [],
  assessmentTemplates: [],
  assessmentFreeTemplates: [],

  assessmentDetail: 'loading',
}

export default function reducer(state = initialState, action = {}) {
  const { content } = state.assessmentDetail
  switch (action.type) {
    case SET_ASSESSMENT_DETAIL:
      return {
        ...state,
        assessmentDetail: action.assessmentDetail,
      }
    case SET_LOADING_ASSESSMENTS:
      return {
        ...state,
        loadingAssessments: true,
      }
    case SET_ASSESSMENTS:
      return {
        ...state,
        freeAssessments: action.freeAssessments,
        assessmentTemplates: action.assessmentTemplates,
        customAssessments: action.customAssessments,
        loadingAssessments: false,
      }
    case UPDATE_TIME_LEFT_CURRENT_QUESTION:
      content[0].timeLeft -= 1
      return {
        ...state,
        assessmentDetail: {
          ...state.assessmentDetail,
        },
      }
    case UPDATE_ASSESSMENT_USED_HINTS:
      return {
        ...state,
        assessmentDetail: {
          ...state.assessmentDetail,
          content: content.map((c) => {
            if (c.uuid === action.contentUUID) {
              const newContent = {
                ...c,
                usedHints: {
                  ...c.usedHints,
                  [action.hintType]: action.points,
                },
              }
              return newContent
            }
            return c
          }),
        },
      }
    case SHIFT_COMPLETED_ASSESSMENT_CONTENT:
      content.shift()
      return {
        ...state,
        assessmentDetail: {
          ...state.assessmentDetail,
          content: [
            ...content,
          ],
        },
      }
    default:
      return state
  }
}

export const shiftCompletedAssessmentContent = () => ({
  type: SHIFT_COMPLETED_ASSESSMENT_CONTENT,
})

export const updateTimeLeftCurrentQuestion = () => ({
  type: UPDATE_TIME_LEFT_CURRENT_QUESTION,
})

export const fetchAssessments = (organizationUUID) => (dispatch, getState) => {
  const state = getState()
  api({
    method: 'get',
    url: `${settings.urls.hacker}/organizations/${organizationUUID}/assessments`,
    idToken: state.auth.user.idToken,
  })
    .then(({ data }) => {
      dispatch({
        type: SET_ASSESSMENTS,
        freeAssessments: data.free_assessments,
        assessmentTemplates: data.assessments_templates,
        customAssessments: data.custom_assessments,
      })
    })
    .catch((err) => {
      console.error(err)
    })
}

export const getAssessmentReportDetail = (organizationUUID, assessmentUUID, callback) => (dispatch, getState) => {
  const state = getState()
  api({
    method: 'get',
    url: `${settings.urls.hacker}/organizations/${organizationUUID}/assessments/${assessmentUUID}`,
    idToken: state.auth.user.idToken,
  })
    .then(({ data }) => {
      if (callback) callback(data)
    })
    .catch((err) => {
      console.error({ err })
    })
}

export const createOrUpdateAssessment = (uuid, organizationUUID, title, description, hintsActive, contentUUIDS, metadata, callback) => (dispatch, getState) => {
  const state = getState()
  api({
    method: uuid ? 'patch' : 'post',
    url: `${settings.urls.hacker}/organizations/${organizationUUID}/assessments`,
    idToken: state.auth.user.idToken,
    data: {
      uuid,
      title,
      description,
      hints_active: hintsActive,
      content_uuids: contentUUIDS ? JSON.stringify(contentUUIDS) : null,
      metadata,
    },
  })
    .then(({ data }) => {
      if (data.success) {
        dispatch(fetchAssessments(organizationUUID))
        if (typeof callback === 'function') callback()
      }
    })
    .catch((err) => {
      console.error(err)
    })
}

export const getAssessmentDetail = (assessmentUUID, callback = null, dontLoadDetail = false) => (dispatch, getState) => {
  const state = getState()
  api({
    method: 'get',
    url: `${settings.urls.hacker}/assessment/${assessmentUUID}`,
    idToken: state.auth.user.idToken,
    params: {
      is_edit: dontLoadDetail || null,
    },
  })
    .then(({ data }) => {
      if (!dontLoadDetail) {
        dispatch({
          type: SET_ASSESSMENT_DETAIL,
          assessmentDetail: data,
        })
        dispatch({
          type: SET_VERSIONS,
          versions: [],
        })
        if (data.content.length > 0) {
          dispatch({
            type: SET_INITIAL_FILE,
            initialFile: data.content[0].metadata.defaultFile,
            engine: data.content[0].metadata.language.name,
          })
        }
      }
      if (callback) callback(data)
    })
    .catch((err) => {
      console.error(err)
    })
}

export const updateAssessment = (assessmentUUID, contentUUID, completed, passed, callback) => (dispatch, getState) => {
  const state = getState()
  api({
    method: 'post',
    url: `${settings.urls.hacker}/assessment/${assessmentUUID}`,
    idToken: state.auth.user.idToken,
    data: {
      content_uuid: contentUUID,
      completed,
      passed,
    },
  })
    .then(({ data }) => {
      if (callback) callback()
    })
    .catch((err) => {
      console.error(err)
    })
}

export const deleteAssessment = (organizationUUID, assessmentUUID, callback) => (dispatch, getState) => {
  const state = getState()
  api({
    method: 'delete',
    url: `${settings.urls.hacker}/organizations/${organizationUUID}/assessments/${assessmentUUID}`,
    idToken: state.auth.user.idToken,
  })
    .then(() => {
      if (callback) callback()
    })
    .catch((err) => {
      console.error(err)
    })
}

export const createAssessmentFromWizard = (organizationUUID, teams, appName, time, language) => (dispatch, getState) => {
  const state = getState()
  api({
    method: 'post',
    url: `${settings.urls.hacker}/organization/${organizationUUID}/assessment/wizard`,
    idToken: state.auth.user.idToken,
    data: {
      teams: teams || undefined,
      app_name: appName || undefined,
      time,
      language: language || undefined,
    },
  })
    .then(() => {
      window.location.assign(`/admin/${organizationUUID}/assessments`)
    })
    .catch((err) => {
      console.error(err)
    })
}
